<template>
  <v-container class="px-1">
    <v-form ref="filterIdentPgtoForm">
      <v-row>
          <v-col class="py-0 px-2" cols="12" sm="6" md="2">
          <label>Data entre</label>
          <v-menu
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateIFormatted"
                dense
                v-mask="'##/##/####'"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="dateI = parseDate(dateIFormatted)"
                :rules="[formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker color="primary"  v-model="dateI" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="py-0 px-2" cols="12" sm="6" md="2">
          <label>até</label>
          <v-menu
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFFormatted"
                v-mask="'##/##/####'"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                dense
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="dateF = parseDate(dateFFormatted)"
                :rules="[formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker color="primary"  v-model="dateF" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
         <v-col class="py-0 px-2" cols="2">
            <label>Status</label>
            <v-select
              v-model="formData.status"
              :items="statusFilter"
              item-value="id"
              item-text="descricao"
              :menu-props="{ bottom: true, offsetY: true }"
              flat
              solo
              dense
              outlined
            >
              <template v-slot:item="data">
                <template v-if="(typeof data.item!=='object')">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.descricao"></v-list-item-title>
                  </v-list-item-content>
                   <v-list-item-icon>
                    <v-icon v-text="data.item.icon" :color="data.item.color" small></v-icon>
                  </v-list-item-icon>
                </template>
              </template>
            </v-select>
            <!-- <label>Status</label>
            <v-select
                v-model="formData.status"
                :items="statusFilter"
                item-value="id"
                item-text="descricao"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
                @change="filterEvento"
            ></v-select> -->
          </v-col>
        <v-spacer />
        <v-col class="pb-0 pt-5 px-2" cols="12" sm="12" md="4">
          <v-text-field
            v-model="formData.ident_prest"
            prepend-inner-icon="mdi-magnify"
            placeholder="Busca por Ident. do Prestador na Operadora"
            single-line
            outlined
            dense
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="3" class="px-3 py-0">
            <label>Prestador</label>
            <v-autocomplete
              v-model="formData.prestador_id"
              :items="prestadoresFilter"
              item-value="id"
              item-text="prest_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="prestadoresFilter.length==1"
              :search-input.sync="searchInput"
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'prestador_id')" :class="formData.prestador_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.prest_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.prestador_id.length>1? 'max-width:30%':'max-width:100%'">{{
              data.item.prest_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.prestador_id.length == 3
                  ? formData.prestador_id.length - 2 + " outro"
                  : formData.prestador_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
          <!-- <v-col class="py-0 px-2" cols="12" sm="6" md="3">
            <label>Prestador</label>
            <v-select
                v-model="formData.prestador_id"
                :items="prestadoresFilter"
                item-value="id"
                item-text="prest_nome"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
                multiple
                @change="changePrestador"
            ></v-select>
          </v-col> -->
        <v-col cols="12" sm="6" md="3" class="px-3 py-0">
            <label>Operadoras</label>
            <v-autocomplete
              v-model="formData.operadora_ans_id"
              :items="operadorasFilter"
              item-value="id"
              item-text="oper_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="operadorasFilter.length==1"
              :search-input.sync="searchInput"
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'operadora_ans_id')" :class="formData.operadora_ans_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.oper_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.operadora_ans_id.length>1? 'max-width:30%':'max-width:100%'">{{
              data.item.oper_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.operadora_ans_id.length == 3
                  ? formData.operadora_ans_id.length - 2 + " outro"
                  : formData.operadora_ans_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
          <!-- <v-col class="py-0 px-2" cols="3">
            <label>Operadora</label>
            <v-select
                v-model="formData.operadora_ans_id"
                :items="operadorasFilter"
                item-value="id"
                item-text="oper_nome"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
                multiple
            ></v-select>
          </v-col> -->
          <v-col cols="12" sm="6" md="4" class="px-3 py-0">
            <label>Evento</label>
            <v-autocomplete
              v-model="formData.evento_id"
              :items="eventosFilter"
              item-value="id"
              item-text="evento"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :search-input.sync="searchInput"
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'evento_id')" :class="formData.evento_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.evento}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.evento_id.length>1? 'max-width:30%':'max-width:100%'">{{
              data.item.evento
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.evento_id.length == 3
                  ? formData.evento_id.length - 2 + " outro"
                  : formData.evento_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
          <!-- <v-col class="py-0 px-2" cols="2">
            <label>Evento</label>
            <v-select
                v-model="formData.evento_id"
                :items="eventosFilter"
                item-value="id"
                item-text="evento"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
                multiple
            ></v-select>
          </v-col> -->
          <v-col class="d-flex justify-end pt-5 px-2">
              <v-spacer></v-spacer>
              <v-btn
                small 
                height="32px"
                color="primary"
                class="px-1 mr-3"
                depressed
                @click="formData.hoje=false; sendFilter();"
                >Filtrar</v-btn>
              <v-btn
                outlined
                small 
                height="32px"
                color="primary"
                class="px-1 ml-1"
                depressed
                @click="clearFilters()"
                >Limpar Filtro</v-btn>
          </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapState, mapActions} from 'vuex'
export default {
    data() {
        return {
          dateIFormatted: null,
          dateFFormatted: null,
          dateI: null,
          dateF: null,
          eventosList:[],
          eventosFilter:[],
          formData: {
              grupo_economico: null,
              ident_prest: null,
              dt_inicio: null,
              dt_fim: null,
              prestador_id: [],
              operadora_ans_id: [],
              status: null,
              evento_id: [],
              hoje: false
          },
          operadorasFilter: [],
          prestadoresFilter: [],
          statusFilter: [
            { id: null, descricao: 'Selecione',  color: null},
            { id: 'executado', descricao: "Executado", color: "success", icon: "fa-check-circle" },
            { id: 'em_execucao', descricao: "Em execução", color: "warning", icon: "fas fa-exclamation-triangle"},
            { id: 'com_intercorrencia', descricao: "Com Intercorrência", color: "error", icon: "fas fa-exclamation-circle"}
          ],
          searchInput: null
      }
    },
    computed: {
      ...mapState({
        formRules: state => state.formRules
      }),
    },  
    watch: {
        prestadores:{
            deep: true,
            handler(val){
                this.prestadoresFilter = Array.from(val)
                if (val && val.length==1) {
                    this.formData.prestador_id= [val[0].id]
                } 
                // else {
                //     this.prestadoresFilter.unshift({id: null, prest_nome: "Selecione"})
                // }
            }
        },
        operadoras:{
            deep: true,
            handler(val){
                this.operadorasFilter = Array.from(val)
                if (val && val.length==1) {
                    this.formData.operadora_ans_id= [val[0].id]
                } 
                // this.operadorasFilter.unshift({id: null, oper_nome: "Selecione"})
            }
        },
        hoje(val){
          if(val){
            this.dateI = val.split('T')[0]
            this.dateF = val.split('T')[0]
          }

        },
        dateF(val){
          if (!val) {
            this.dateFFormatted = null
          } else {
            if (!!this.dateI && Date.parse(this.dateI) > Date.parse(val)){
              this.dateI = val
            }
            this.dateFFormatted = this.formatDate(val)
          }
        },
        dateFFormatted(val){
          this.formData.dt_fim = this.parseDate(val)
        },
        dateI(val){
          if (!val) {
            this.dateIFormatted = null
          } else {
            if (!!this.dateF && Date.parse(this.dateF) < Date.parse(val)){
              this.dateF = val
            }
            this.dateIFormatted = this.formatDate(val)
          }
        },
        dateIFormatted(val){
          this.formData.dt_inicio = this.parseDate(val)
        },

    },
    mounted() {
      let stateFilter = this.$store.state.recebiveis.identPagamentosFilter
      this.formData.grupo_economico = this.$store.state.permissions.grupoEconomico
      this.formData = stateFilter? {...stateFilter} : this.formData
      let opts = {
        grupoEconomico: this.formData.grupo_economico,
        modulo_operadora: "recebiveis",
        prestador_ids: []
      }
      this.getOperadoras(opts)
      this.getEventos(true).then(resp => { 
        let limitEvent = resp.filter(el => el.id <= 200)
        this.eventoList = this.eventosFilter = limitEvent
        this.eventosFilter.unshift({id: null, evento: "Selecione" })
        // this.filterEvento()
      })
      this.filterList(this.formData)
    },
    methods: {
        ...mapActions("recebiveis", [
          "getEventos",
        ]),
        changePrestador() {
          let opts = {
            grupoEconomico: this.formData.grupo_economico,
            modulo_operadora: "recebiveis",
            prestador_ids: this.formData.prestador_id
          }
          this.getOperadoras(opts)
          this.formData.operadora_ans_id = []
        },
        clearFilters() {
          this.formData.status = null
          this.formData.hoje = false
          this.formData.evento_id = []
          this.formData.dt_inicio = null
          this.formData.dt_fim = null
          this.dateI = null
          this.dateF = null
          this.formData.ident_prest= null
          this.dateIFormatted = null
          this.dateFFormatted = null
          this.filterList(this.formData)
          if (this.prestadoresFilter.length>1) 
          this.formData.prestador_id = []
          if (this.operadorasFilter.length>1) 
          this.formData.operadora_ans_id = []
        },
        filterEvento() {
          let status = this.formData.status
          if(status != null && status != undefined) {
            this.eventosFilter = [...this.eventoList].filter(evento => evento.erro==status)
            // this.eventosFilter.unshift({id: null, evento: "Selecione" })
          } else {
            this.eventosFilter = [...this.eventoList]
            // this.eventosFilter.unshift({id: null, evento: "Selecione" })
          }
          this.formData.evento_id = [];
        },
        formatDate(date) {
          if (!date) return null;
          const [year, month, day] = date.split("-");
          return `${day}/${month}/${year}`;
        },
        parseDate(date) {
          if (!date) return null;
          const [day, month, year] = date.split("/");
          return `${year}-${month}-${day}`;
        },
        sendFilter(){
          if(this.$refs.filterIdentPgtoForm.validate()){
             if(!this.formData.dt_fim && this.formData.dt_inicio) {
                this.dateF = this.formData.dt_inicio
                this.formData.dt_fim = this.formData.dt_inicio
            }
            this.filterList(this.formData)
          }
        },
        toggleAutocomplete(item, campo) {
          this.searchInput = null
          let index = this.formData[campo].indexOf(item.id)
          //  index > -1  está excluindo a operadora
          if (index > -1) {
            this.formData[campo].splice(index, 1)
          } else {
            //  index < 0  está adicionando a operadora
              this.formData[campo].push(item.id)
          }
            this.$nextTick()
            return
        },
    },
    props: {
        prestadores: Array,
        operadoras: Array,
        filterList: Function,
        getOperadoras: Function,
        hoje: String
    }
}
</script>

<style>
.v-text-field--filled.v-input--dense.v-text-field--single-line .v-label, .v-text-field--full-width.v-input--dense.v-text-field--single-line .v-label {
    top: 7px;
}
</style>